/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setRespirationRateEffortOptions } from '../store/options.actions'

export function* getRespirationRateEffort() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const respirationRateEffortResponse = yield call([vitalsService, vitalsService.getRespirationRateEffort])
    const { entity } = respirationRateEffortResponse
    yield put(setRespirationRateEffortOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRespirationRateEffort() error: ${e}`))
  }
}

export function* getRespirationRateEffortSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRespirationRateEffort)
}
